import { api } from "./api";

export const CustomerList = (params) => {
  return api.get(`/manufacturer/customer-v2/doctor-list`, { params });
};

export const CustomerDetail = (params) => {
  return api.get(`/manufacturer/customer-v2/doctor-view`, {
    params: params,
  });
};

export const CustomerPharmacyList = (params) => {
  return api.get(`/manufacturer/customer-v2/pharmacy-list`, { params });
};

export const CustomerPharmacyDetail = (params) => {
  return api.get(`/manufacturer/customer-v2/pharmacy-view`, {
    params: params,
  });
};

export const subcriberRequestList = (params) => {
  return api.get(`/manufacturer/customer-v2/doctor-onboarding-list`, {
    params,
  });
};

export const subcriberRequestDetail = (params) => {
  return api.get(`/manufacturer/customer-v2/doctor-onboarding-view`, {
    params: params,
  });
};

export const subcriberRequestPharmacyList = (params) => {
  return api.get(`/manufacturer/customer-v2/pharmacy-onboarding-list`, {
    params,
  });
};

export const subcriberRequestPharmacyDetail = (params) => {
  return api.get(`/manufacturer/customer-v2/pharmacy-onboarding-view`, {
    params: params,
  });
};

export const customerSubcriberRequestList = (params) => {
  return api.get(`/manufacturer/customer/subscribe-request-list`, {
    params,
  });
};

export const customerSubcriberRequestDetail = (params) => {
  return api.get(`/manufacturer/customer/subscribe-request-view`, {
    params: params,
  });
};

export const updateDoctorType = (params) => {
  return api.post(
    `/manufacturer/customer-v2/change-doctor-type`,
    JSON.stringify(params)
  );
};

export const updatePharmacyType = (params) => {
  return api.post(
    `/manufacturer/customer-v2/change-pharmacy-type`,
    JSON.stringify(params)
  );
};

export const customerVersionList = (params) => {
  return api.get(`/manufacturer/customer/version-history-list`, { params });
};

export const customerVersionDetail = (params) => {
  return api.get(`/manufacturer/customer/version-history-view`, {
    params: params,
  });
};

export const approveRejectCustomer = (params) => {
  return api.post(
    `/manufacturer/customer/approve-reject-subscribe-request`,
    JSON.stringify(params)
  );
};

export const fetchHeadQuarterCustomerApi = (params) => {
  return api.get(`/manufacturer/customer/headquarters-list`, { params });
};
export const customerSendMailApi = (params) => {
  return api.post(`/manufacturer/customer/send-mail`, JSON.stringify(params));
};

export const fetchDivisionsApi = (params) => {
  return api.get(`/manufacturer/customer/divisions-list`, { params });
};

export const fetchHQDivisionalFeildForceUsers = (params) => {
  return api.post(
    `/manufacturer/customer/fetch-hq-divisonal-feild-force-users`,
    JSON.stringify(params)
  );
};

export const addDivisionToCustomer = (params) => {
  return api.post(
    `/manufacturer/customer/add-division-to-customer`,
    JSON.stringify(params)
  );
};

export const deleteDivisionFromCustomer = (params) => {
  return api.post(
    `/manufacturer/customer/delete-division-from-customer`,
    JSON.stringify(params)
  );
};

export const productOfferRequestListApi = (params) => {
  return api.get(`/manufacturer/product/doctor-product-request/list`, {
    params,
  });
};

export const pharmacyroductOfferRequestListApi = (params) => {
  return api.get(`/manufacturer/product/pharmacy-product-request/list`, {
    params,
  });
};

export const productOfferRequestViewApi = (params) => {
  return api.get(`/manufacturer/product/doctor-product-request/read`, {
    params,
  });
};

export const pharmacyProductOfferRequestViewApi = (params) => {
  return api.get(`/manufacturer/product/pharmacy-product-request/read`, {
    params,
  });
};

export const productOfferRequestApproveAllApi = (params) => {
  return api.get(`/manufacturer/product/doctor-product-request/approve-all`, {
    params,
  });
};

export const productOfferRequestRejectAllApi = (params) => {
  return api.get(`/manufacturer/product/doctor-product-request/reject-all`, {
    params,
  });
};

export const pharmacyProductOfferRequestApproveAllApi = (params) => {
  return api.get(`/manufacturer/product/pharmacy-product-request/approve-all`, {
    params,
  });
};

export const pharmacyProductOfferRequestRejectAllApi = (params) => {
  return api.get(`/manufacturer/product/pharmacy-product-request/reject-all`, {
    params,
  });
};

export const productOfferRequestApproveRejectApi = (params) => {
  return api.get(
    `/manufacturer/product/doctor-product-request/approve-reject`,
    {
      params,
    }
  );
};

export const pharmacyProductOfferRequestApproveRejectApi = (params) => {
  return api.get(
    `/manufacturer/product/pharmacy-product-request/approve-reject`,
    {
      params,
    }
  );
};

export const productOffersListApi = (params) => {
  return api.get(
    `/manufacturer/product/doctor-product-request/list-of-offers`,
    {
      params,
    }
  );
};

export const pharmacyProductOffersListApi = (params) => {
  return api.get(
    `/manufacturer/product/pharmacy-product-request/list-of-offers`,
    {
      params,
    }
  );
};

export const onboardDoctorProductOffersListApi = (params) => {
  return api.get(`/manufacturer/customer-v2/doctor-product-list`, {
    params,
  });
};

export const onboardPharmacyProductOffersListApi = (params) => {
  return api.get(`/manufacturer/customer-v2/pharmacy-product-list`, {
    params,
  });
};

export const productOfferRequestEditApi = (params) => {
  return api.get(`/manufacturer/product/doctor-product-request/update-offer`, {
    params,
  });
};

export const pharmacyProductOfferRequestEditApi = (params) => {
  return api.get(
    `/manufacturer/product/pharmacy-product-request/update-offer`,
    {
      params,
    }
  );
};

export const productOfferRequestRemoveApi = (params) => {
  return api.post(
    `/manufacturer/customer/product-offer-request/delete-offer`,
    JSON.stringify(params)
  );
};

export const productOfferRequestAddApi = (params) => {
  return api.post(
    `/manufacturer/customer/product-offer-request/add-offer`,
    JSON.stringify(params)
  );
};

export const productOffersDivsionProductsListApi = (params) => {
  return api.get(
    `/manufacturer/customer/product-offer-request/division-products-list`,
    { params }
  );
};
export const customerAddProductListApi = (params) => {
  return api.get(`/manufacturer/customer-v2/product-add-list`, {
    params,
  });
};
export const customerAddProductOfferListApi = (params) => {
  return api.get(`/manufacturer/customer-v2/product-add-offer-list`, {
    params,
  });
};

export const addCustomerProduct = (params) => {
  return api.post(
    `/manufacturer/customer-v2/doctor-add-product`,
    JSON.stringify(params)
  );
};

export const addPharmacyProduct = (params) => {
  return api.post(
    `/manufacturer/customer-v2/pharmacy-add-product`,
    JSON.stringify(params)
  );
};
